import { Component, OnInit } from '@angular/core';
import { EnterpriseSettingService } from 'src/app/services/enterprise-setting/enterprise-setting.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';

@Component({
  selector: 'app-visit-schedule',
  templateUrl: './visit-schedule.component.html',
  styleUrls: ['./visit-schedule.component.css']
})
export class VisitScheduleComponent implements OnInit {

  scheduled = [];
  idEnterprise: number;
  idUser: number;
  color1: String;
  color2: String;
  constructor(private enterpriseSettingService: EnterpriseSettingService,) {
    this.setTheme();
  }

  ngOnInit() {
    this.list();
  }

  list(){
    this.enterpriseSettingService
      .getEnterpriseSettingVisitSchedule(this.idEnterprise)
      .subscribe(
        (response) => {
          this.scheduled = response.data;
        });
  }

  setTheme() {
    this.idEnterprise = +localStorage.getItem(AppConstants.Session.ENTERPRISE);
    this.idUser = +localStorage.getItem(AppConstants.Session.USERID);
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
  }

}
